export default "__VITE_ASSET__BqPbxuSm__"